import { fetchPrediction } from 'utils/api'

const getCommandFromPrediction = (editor, prediction) => {
  const { command } =
    editor
      .getAllHoverMenuButtons()
      .find(action => action.type === prediction) || {}
  return command
}

export const PredictPlugin = (options = {}) => {
  return {
    commands: {
      async predictUnstructured(editor) {
        if (!editor.props.isPredictive) return

        const { document } = editor.value
        const lineGroups = document.nodes.filter(
          node => node.type === 'lineGroup' && node.text
        )
        const text = lineGroups
          .filter(node => !node.data.get('userModified'))
          .map(node => node.nodes.map(childNode => childNode.text).toArray())
          .toArray()

        const resp = await fetchPrediction(text)
        const { predictions = [] } = resp.data

        lineGroups.forEach((node, i) => {
          const command = getCommandFromPrediction(editor, predictions[i])

          if (command) {
            editor[command](node, { userModified: false })
          }
        })
      },
      async predictSurveyElement(editor, node) {
        if (!editor.props.isPredictive) return

        const resp = await fetchPrediction([
          node.nodes.map(n => n.text).toArray()
        ])
        const { predictions: [prediction] = [] } = resp.data
        const command = getCommandFromPrediction(editor, prediction)

        if (command) {
          editor[command](node)
        }
      }
    }
  }
}

export default PredictPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/PredictPlugin.js